import { ErrorHandler, NgModule } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { environment } from '../environments/environment';

import Bugsnag from '@bugsnag/js';
import { BugsnagErrorHandler } from '@bugsnag/plugin-angular';

const ignoreMessages = [
  'Java exception was raised during method invocation',
  'Java object is gone',
  'window.webkit.messageHandlers',
  'installations/app-offline',
  'auth/network-request-failed',
];

export const bugsnagClient = Bugsnag.start({
  apiKey: environment.bugsnagApiKey,
  enabledReleaseStages: ['production', 'canary'],
  releaseStage: environment.releaseStage,
  autoTrackSessions: false,
  appVersion: environment.appVersion,
  onError: event => {
    const msg = `${event.errors?.[0]?.errorMessage || ''}_${event.originalError?.toString?.() || ''}`;
    return !ignoreMessages.some(m => msg.includes(m));
  },
});

export class BugHandler extends BugsnagErrorHandler {
  readonly chunkLoadError = 'ChunkLoadError';

  override handleError(error: any): void {
    try {
      const message = error?.message || '';
      const errorString = error?.toString?.() || '';
      if (ignoreMessages.some(msg => message.includes(msg) || errorString.includes(msg))) {
        // ignore target error
        return;
      }
      if (error instanceof HttpErrorResponse && error.status === 0) {
        // ignore network error
        return;
      }
    } catch {
      // ignore
    }
    super.handleError(error);
    if (typeof error.message === 'string' && error.message.includes(this.chunkLoadError)) {
      try {
        window.location.reload();
      } catch {
        // ignore error
      }
    }
  }
}

export function errorHandlerFactory(): BugsnagErrorHandler {
  return new BugHandler(bugsnagClient);
}

@NgModule({
  providers: [{ provide: ErrorHandler, useFactory: errorHandlerFactory }],
})
export class BugsangModule {}
